import React from "react"

import { faClock } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import moment from "moment-timezone"

import { NIRVANA_COLORS } from "@front-shared/config/theme.config"
import { ButtonElement } from "@front-shared/elements/button.element"
import { PrimaryText } from "@front-shared/elements/primaryText.element"

export const PayerStatusStaleBannerComponent: React.FunctionComponent<
    IPayerStatusStaleBannerComponentProps
> = props => {
    return (
        <div
            role="status"
            className="flex flex-wrap items-start gap-[14px] rounded-[14px] border border-solid border-brand-warmLight2 bg-brand-white px-[20px] py-[16px]"
        >
            <FontAwesomeIcon
                icon={faClock}
                className="mt-[4px]"
                style={{ color: NIRVANA_COLORS.brand.orange }}
            />

            <div className="min-w-0 flex-[1_1_280px]">
                <PrimaryText typography="textSemibold">
                    Status may be out of date
                </PrimaryText>

                <PrimaryText className="opacity-60">
                    {`We haven’t been able to refresh payer status for ${moment
                        .duration(props.failedAt - props.fetchedAt)
                        .humanize()}, so what you see below may not reflect what’s happening now.`}
                </PrimaryText>
            </div>

            <ButtonElement
                htmlType="button"
                type="default"
                size="middle"
                label="Refresh"
                isLoading={props.isLoading}
                onClick={props.onRefresh}
            />
        </div>
    )
}

interface IPayerStatusStaleBannerComponentProps {
    fetchedAt: number
    failedAt: number // last failed refresh
    isLoading: boolean
    onRefresh: () => void
}
